module.exports = __webpack_public_path__ + "img/case_9.e94d7783.png";